import { format, formatISO, isValid, parse, parseISO } from 'date-fns';
import { IMask } from 'react-imask';
export const formats = {
    'yyyy-mm-dd': {
        imask: (minYear, maxYear) => ({
            mask: 'y-`m-`d',
            lazy: false,
            overwrite: true,
            blocks: imaskBlocks(minYear, maxYear),
        }),
        parse: (value) => {
            const date = parseISO(value);
            if (isValid(date)) {
                return value;
            }
            else {
                return undefined;
            }
        },
        format: (value) => value,
    },
    'dd.mm.yyyy': {
        imask: (minYear, maxYear) => ({
            mask: 'd{.}`m{.}`y',
            lazy: false,
            overwrite: true,
            blocks: imaskBlocks(minYear, maxYear),
        }),
        parse: (value) => {
            const date = parse(value, 'dd.MM.yyyy', new Date());
            if (isValid(date)) {
                return formatISO(date, { representation: 'date' });
            }
            else {
                return undefined;
            }
        },
        format: (value) => {
            const date = parseISO(value);
            if (isValid(date)) {
                return format(date, 'dd.MM.yyyy');
            }
            else {
                return value;
            }
        },
    },
    'mm/dd/yyyy': {
        imask: (minYear, maxYear) => ({
            mask: 'm/`d/`y',
            lazy: false,
            overwrite: true,
            blocks: imaskBlocks(minYear, maxYear),
        }),
        parse: (value) => {
            const date = parse(value, 'MM/dd/yyyy', new Date());
            if (isValid(date)) {
                return formatISO(date, { representation: 'date' });
            }
            else {
                return undefined;
            }
        },
        format: (value) => {
            const date = parseISO(value);
            if (isValid(date)) {
                return format(date, 'MM/dd/yyyy');
            }
            else {
                return value;
            }
        },
    },
};
function imaskBlocks(minYear, maxYear) {
    return {
        d: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
            maxLength: 2,
        },
        m: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
        },
        y: {
            mask: IMask.MaskedRange,
            from: minYear,
            to: maxYear,
            maxLength: 4,
        },
    };
}
